import * as angular from 'angular';

class BundleSlotNumberAllowedValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpBundleSlotNumberAllowedValidator'] =
            BundleSlotNumberAllowedValidator.validate;

        scope.$watch(
            function () {
                return scope.$eval(attrs['slotOrder']);
            },
            function () {
                ngModelCtrl.$validate();
            },
            true
        );
    };

    private static validate(modelValue: any, viewValue: any): boolean {
        if (!modelValue) {
            return true;
        }
        if (!angular.isUndefined(modelValue) && modelValue.length > 0) {
            return true;
        }

        //ToDo: add some logic here...

        return false;
    }
}

angular
    .module('app')
    .directive(
        'pkpBundleSlotNumberAllowedValidator',
        () => new BundleSlotNumberAllowedValidator()
    );
